/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["files-grid{display:flex;flex-wrap:wrap;align-content:start;margin:-8px}files-grid:empty{margin:0}"];
export { styles as styles };
